import { useLang } from '../context/LanguageContext';
import { MOBILE_APP } from '../config/business';

function PlayStoreIcon() {
  return (
    <svg className="app-footer__store-svg" viewBox="0 0 24 24" aria-hidden>
      <path fill="#4285F4" d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12 3.84 21.85C3.34 21.6 3 21.09 3 20.5Z" />
      <path fill="#34A853" d="M16.81 15.12 6.05 21.34l8.49-8.49 2.27 2.27Z" />
      <path fill="#FBBC04" d="M20.16 10.81c.34.27.59.69.59 1.19s-.25.92-.59 1.19l-2.29 1.32L15.39 12l2.5-2.5 2.27 1.31Z" />
      <path fill="#EA4335" d="M6.05 2.66 16.81 8.88 14.54 11.15 6.05 2.66Z" />
    </svg>
  );
}

function AppStoreIcon() {
  return (
    <svg className="app-footer__store-svg" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M16.365 20.752c-.724.665-1.59.99-2.474.916-.866-.074-1.698-.41-2.654-.41-.98 0-1.84.336-2.652.41-.9.074-1.86-.26-2.6-.926C2.866 17.227 3.42 10.59 8.68 10.26c1.09.06 1.86.59 2.504.63 1.01-.21 1.97-.81 3.06-.74 1.26.1 2.17.59 2.78 1.47-2.62 1.55-2.2 5.56.44 6.68-.5 1.32-1.15 2.6-2.2 3.55ZM12.03 7.25c-.05-2.1 1.7-3.9 3.74-4.1.28 2.34-2.1 4.12-3.74 3.85Z"
      />
    </svg>
  );
}

function StoreBadge({ type, label, soonLabel, href }) {
  const live = !!href && !MOBILE_APP.comingSoon;
  const Icon = type === 'play' ? PlayStoreIcon : AppStoreIcon;
  const className = `app-footer__store-badge app-footer__store-badge--${type}${live ? ' app-footer__store-badge--live' : ''}`;

  const inner = (
    <>
      <span className="app-footer__store-icon-box">
        <Icon />
      </span>
      <span className="app-footer__store-text">
        <span className="app-footer__store-platform">{label}</span>
        {!live && <span className="app-footer__store-soon">{soonLabel}</span>}
        {live && <span className="app-footer__store-cta">Download</span>}
      </span>
    </>
  );

  if (live) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={className}>
        {inner}
      </a>
    );
  }

  return (
    <span className={className} aria-label={`${label} — ${soonLabel}`}>
      {inner}
    </span>
  );
}

export default function FooterAppStores() {
  const { t } = useLang();

  return (
    <div className="app-footer__store-badges">
      <StoreBadge
        type="play"
        label={t.mobileAppPlay}
        soonLabel={t.mobileAppSoon}
        href={MOBILE_APP.playStoreUrl}
      />
      <StoreBadge
        type="ios"
        label={t.mobileAppIos}
        soonLabel={t.mobileAppSoon}
        href={MOBILE_APP.appStoreUrl}
      />
    </div>
  );
}
